import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h4 {
    margin: 0;
    font-weight: bold;
  }

  ${(props) =>
    props.browserZoomLevel > 100 &&
    css`
      max-height: 85vh;
    `}
`;
